import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function FiltriTest() {

    const location = useLocation();
    const navigate = useNavigate();

    const [manufacturer, setManufacturer] = useState('');  // филтер за марка на масло
    const [sortBy, setSortBy] = useState("");
    const [selectedViscosities, setSelectedViscosities] = useState([]);


    // Sync the filters with the URL query params
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        setManufacturer(queryParams.get('manufacturer') || '');
        setSelectedViscosities(queryParams.getAll('viscosity') || []);
        setSortBy(queryParams.get('sortBy') || '');

    }, [location.search]);

    const applyFilters = () => {
        const newQueryParams = new URLSearchParams(location.search);

        newQueryParams.set('currentPage', 1)
        // Додај ги само новите selected viscosities во URL
        const currentViscosities = new Set(newQueryParams.getAll('viscosity')); // Сите вредности на 'viscosity'

        // Додај ги сите selected viscosities во URL
        selectedViscosities.forEach((viscosity) => {
            if (!currentViscosities.has(viscosity)) {
                newQueryParams.append('viscosity', viscosity); // Додај ја ако не постои
            }
        });

        // Увери се дека сите избришани viscosity ќе бидат отстранети
        currentViscosities.forEach((viscosity) => {
            if (!selectedViscosities.includes(viscosity)) {
                newQueryParams.delete('viscosity', viscosity); // Избриши ја ако ја нема во selectedViscosities
            }
        });

        // Управување со manufacturer параметарот
        if (manufacturer) {
            newQueryParams.set("manufacturer", manufacturer);
        } else {
            newQueryParams.delete("manufacturer"); // Избриши ако нема вредност
        }

        // Навигирај со новите query параметри
        navigate({ search: newQueryParams.toString() });
    };

    const handleViscosityChange = (e) => {
        const value = e.target.value;
        setSelectedViscosities(prevState => {
            if (prevState.includes(value)) {
                return prevState.filter(viscosity => viscosity !== value);
            } else {
                return [...prevState, value];
            }
        });
    };

    const handleSortByChange = (e) => {
        const newQueryParams = new URLSearchParams(location.search);
        const { name, value } = e.target;

        if (value) {
            newQueryParams.set(name, value);
        } else {
            newQueryParams.delete(name); // Избриши ако нема вредност
        }
        setSortBy(e.target.value);

        navigate({ search: newQueryParams.toString() });
    };

    const handleManufacturerChange = (e) => {
        setManufacturer(e.target.value);
    };


    return (
        <>
            <div className='ml-auto'>
                <select
                    className="mb-4 select select-xs"
                    name='sortBy'
                    value={sortBy}
                    onChange={handleSortByChange}
                >
                    <option value="">Стандардно подредување</option>
                    <option value="price_asc">Цена &uarr; (ниска кон висока)</option>
                    <option value="price_desc">Цена &darr; (висока кон ниска)</option>
                    <option value="createdate">Најново додадено</option>
                </select>
            </div>
            <div className="flex flex-wrap justify-center ">
                <div className="child p-2 w-full sm:w-auto">
                    <select
                        name='manufacturer'
                        value={manufacturer}
                        onChange={handleManufacturerChange}
                        className='mt-2 select select-sm'
                    >
                        <option value="">Сите брендови</option>
                        <option value="Mobil">Mobil</option>
                        <option value="Motul">Motul</option>
                        <option value="Valvoline">Valvoline</option>
                        <option value="Castrol">Castrol</option>
                        <option value="Shell">Shell</option>
                        <option value="Fuchs">Fuchs Titan</option>
                        <option value="Total">Total</option>
                        <option value="Elf">Elf</option>
                        <option value="Mannol">Mannol</option>
                        <option value="Aral">Aral</option>
                        <optgroup label="Брендирани масла">
                            <option value="BMW">BMW</option>
                            <option value="Mercedes-Benz">Mercedes-Benz</option>
                            <option value="VAG">Volkswagen (VAG)</option>
                            <option value="GM">Opel GM</option>
                            <option value="Ford">Ford</option>
                        </optgroup>
                    </select>
                </div>
                <div className="child p-2 w-full sm:w-auto">
                    <div className='flex flex-wrap'>
                        <div className="form-control">
                            <label className="label cursor-pointer ml-2">
                                <span className="label-text checkbox-xs">0W-20</span>
                                <input type="checkbox" name='viscosity' value="0W-20" checked={selectedViscosities.includes("0W-20")}
                                    onChange={handleViscosityChange} className="checkbox checkbox-success checkbox-sm ml-1" />
                            </label>
                        </div>
                        <div className="form-control">
                            <label className="label cursor-pointer ml-2">
                                <span className="label-text checkbox-xs">0W-30</span>
                                <input type="checkbox" name='viscosity' value="0W-30" checked={selectedViscosities.includes("0W-30")}
                                    onChange={handleViscosityChange} className="checkbox checkbox-success checkbox-sm ml-1" />
                            </label>
                        </div>
                        <div className="form-control">
                            <label className="label cursor-pointer ml-2">
                                <span className="label-text checkbox-xs">5W-20</span>
                                <input type="checkbox" name='viscosity' value="5W-20" checked={selectedViscosities.includes("5W-20")}
                                    onChange={handleViscosityChange} className="checkbox checkbox-success checkbox-sm ml-1" />
                            </label>
                        </div>
                        <div className="form-control">
                            <label className="label cursor-pointer ml-2">
                                <span className="label-text checkbox-xs">5W-30</span>
                                <input type="checkbox" name='viscosity' value="5W-30" checked={selectedViscosities.includes("5W-30")}
                                    onChange={handleViscosityChange} className="checkbox checkbox-success checkbox-sm ml-1" />
                            </label>
                        </div>
                        <div className="form-control">
                            <label className="label cursor-pointer ml-2">
                                <span className="label-text checkbox-xs">5W-40</span>
                                <input type="checkbox" value="5W-40" name='viscosity'
                                    checked={selectedViscosities.includes("5W-40")}
                                    onChange={handleViscosityChange} className="checkbox checkbox-success checkbox-sm ml-1" />
                            </label>
                        </div>
                        <div className="form-control">
                            <label className="label cursor-pointer ml-2">
                                <span className="label-text">10W-40</span>
                                <input type="checkbox" value="10W-40" name='viscosity'
                                    checked={selectedViscosities.includes("10W-40")}
                                    onChange={handleViscosityChange} className="checkbox checkbox-success checkbox-sm ml-1" />
                            </label>
                        </div>
                        <div className="form-control">
                            <label className="label cursor-pointer ml-2">
                                <span className="label-text">15W-40</span>
                                <input type="checkbox" value="15W-40" name='viscosity'
                                    checked={selectedViscosities.includes("15W-40")}
                                    onChange={handleViscosityChange} className="checkbox checkbox-success checkbox-sm ml-1" />
                            </label>
                        </div>
                        <div className="form-control">
                            <label className="label cursor-pointer ml-2">
                                <span className="label-text">10W-60</span>
                                <input type="checkbox" value="10W-60" name='viscosity'
                                    checked={selectedViscosities.includes("10W-60")}
                                    onChange={handleViscosityChange} className="checkbox checkbox-success checkbox-sm ml-1" />
                            </label>
                        </div>
                    </div>
                </div>
                <div className="child p-2 w-full sm:w-auto">
                    <button
                        onClick={applyFilters}
                        className="btn btn-third btn-sm md:ml-10 lg:ml-10 xl:ml-10"
                    >
                        Примени филтри
                    </button>
                </div>
            </div>
        </>
    )
}
export default FiltriTest
